import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import FusionAuthService from "../services/fusionAuthService";

const PrivateRoute = () => {
  return FusionAuthService.isAuthenticated() ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;